package com.essntl.features.tag.ui.addedittag

import com.essntl.features.tag.domain.model.TagModel

sealed interface AddEditTagEvent {
    data class GetTag(val id: String) : AddEditTagEvent
    data class UpdateTagFields(val tag: TagModel) : AddEditTagEvent
    data object EditTag : AddEditTagEvent
    data object DeleteTag : AddEditTagEvent
    data object ClearState : AddEditTagEvent
}